export default "__VITE_ASSET__3K7b_A4x__"